import { CircleDot, Dumbbell, Gauge, PersonStanding, Route } from 'lucide-react'
import type { Exercise } from '../domain/types'

export function Artwork({ exercise, size = 68 }: { exercise: Exercise; size?: number }) {
  const Icon = exercise.category === 'Anillas'
    ? CircleDot
    : exercise.category === 'Abs'
      ? PersonStanding
      : exercise.category === 'HYROX'
        ? Route
        : exercise.category === 'Piernas'
          ? Gauge
          : Dumbbell

  return (
    <div className="exercise-art" style={{ '--art-size': `${size}px` } as React.CSSProperties} aria-hidden="true">
      <span className="art-orbit" />
      <Icon size={Math.round(size * 0.3)} strokeWidth={1.8} />
    </div>
  )
}

